// Authoritative bakery module catalog. Backend authoritative for costs/CPS.

export type ModuleDef = {
  id: string;
  name: string;
  baseCps: bigint;
  baseCost: bigint;
  maxLevel: number;
  requiredBakeryLevel: number;
  requires?: { id: string; level: number };
};

export const MODULES: Record<string, ModuleDef> = {
  oven: { id: "oven", name: "Oven", baseCps: 2n, baseCost: 500n, maxLevel: 60, requiredBakeryLevel: 1 },
  mixer: { id: "mixer", name: "Mixer", baseCps: 1n, baseCost: 300n, maxLevel: 60, requiredBakeryLevel: 1, requires: { id: "oven", level: 5 } },
  packaging: { id: "packaging", name: "Packaging", baseCps: 1n, baseCost: 200n, maxLevel: 60, requiredBakeryLevel: 1 },
  delivery: { id: "delivery", name: "Delivery", baseCps: 4n, baseCost: 800n, maxLevel: 50, requiredBakeryLevel: 2, requires: { id: "packaging", level: 5 } },
  event_kitchen: { id: "event_kitchen", name: "Event Kitchen", baseCps: 2n, baseCost: 3000n, maxLevel: 30, requiredBakeryLevel: 5, requires: { id: "oven", level: 10 } },
  research_lab: { id: "research_lab", name: "Research Lab", baseCps: 10n, baseCost: 6000n, maxLevel: 30, requiredBakeryLevel: 6, requires: { id: "mixer", level: 10 } },
  blast_furnace: { id: "blast_furnace", name: "Blast Furnace", baseCps: 25n, baseCost: 25000n, maxLevel: 25, requiredBakeryLevel: 7, requires: { id: "oven", level: 15 } },
  quantum_oven: { id: "quantum_oven", name: "Quantum Oven", baseCps: 60n, baseCost: 120000n, maxLevel: 20, requiredBakeryLevel: 8, requires: { id: "blast_furnace", level: 5 } },
  star_forge: { id: "star_forge", name: "Star Forge", baseCps: 150n, baseCost: 600000n, maxLevel: 15, requiredBakeryLevel: 9, requires: { id: "quantum_oven", level: 5 } },
  guild_hall: { id: "guild_hall", name: "Guild Hall", baseCps: 400n, baseCost: 2500000n, maxLevel: 10, requiredBakeryLevel: 10, requires: { id: "star_forge", level: 5 } },
};


